import * as React from 'react'
import { AlertsService } from 'src/share/services/alerts';
import { AlertHistoryRow } from './AlertHistoryRow';

const AlertTableDetails = (props) => {
  const [alerts, setAlerts] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    fetchHistory();
  }, []);
  const fetchHistory = async () => {
    const alertsResponse = await AlertsService.history(props.data.id);
    setAlerts(alertsResponse);
    setLoading(false);
  }
  return (
    <div className="alert-control-center__alert-details">
      {loading ?
        <AlertHistoryRow loading={loading} /> :
        alerts.map((alert, index) =>
          <AlertHistoryRow key={`alert-${alert.id}-${index}`} index={index} alert={alert} loading={loading} />
        )}
    </div>
  )
}

export default AlertTableDetails;
